import PigGroupsExportModal from './PigGroupsExportModal';

export default PigGroupsExportModal;
